import "./App.css";
import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AntixLanding from "./components/AntixLanding";
import GlassNavDemo from "./components/GlassNavDemo";
import SubscriptionConfirm from "./components/SubscriptionConfirm";
import LoadingSpinner from "./components/LoadingSpinner";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";

// Lazy load legal pages for better performance
const PrivacyPolicy = React.lazy(() => import("./components/PrivacyPolicy"));
const AntixAppPrivacyPolicy = React.lazy(() => import("./components/AntixAppPrivacyPolicy"));
const TermsOfService = React.lazy(() => import("./components/TermsOfService"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <ErrorBoundary>
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<AntixLanding />} />
              <Route path="/glass-nav-demo" element={<GlassNavDemo />} />
              <Route path="/confirm" element={<SubscriptionConfirm />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/antix-app-privacy" element={<AntixAppPrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </div>
  );
}

export default App;
